/* Dati per la fattura — logica del modale nel carrello.
 *
 * Prima stava dentro snippets/invoice-modal.liquid: qui si mette in cache e si
 * legge meglio. Il markup e lo stile restano nello snippet.
 *
 * CORREZIONI del 19 ottobre 2026 (il resto del comportamento è invariato)
 *
 * 1. CAMPO NASCOSTO NON AGGIORNATO — era il motivo per cui la ragione sociale
 *    spariva dagli ordini. Dopo il salvataggio il codice riallineava gli input
 *    nascosti calcolando l'id come 'cart-attribute-' + chiave, ma la chiave
 *    ragione_sociale ha un underscore mentre l'id dell'input ha il trattino
 *    (cart-attribute-ragione-sociale). L'elemento non veniva trovato, quel campo
 *    restava vuoto, e al primo invio del form del carrello Shopify riscriveva
 *    gli attributi dai campi nascosti cancellando la sola ragione sociale.
 *    Ora gli input si cercano per NAME, che è quello che Shopify legge davvero,
 *    con l'id come riserva.
 *
 * 2. MEMORIA DEL BROWSER — prima, se i campi erano vuoti, il salvataggio pescava
 *    da localStorage: un cliente che aveva chiesto fattura una volta se la
 *    ritrovava allegata agli ordini successivi senza averla richiesta. Ora la
 *    memoria serve solo a RIEMPIRE il modale quando lo si apre: quello che viene
 *    salvato è sempre e solo quello che si vede a schermo.
 *
 * 3. ERRORI INVISIBILI — la validazione scriveva l'errore dentro il modale anche
 *    quando era chiuso, e poi mandava comunque al checkout: un cliente poteva
 *    arrivare al pagamento convinto di aver chiesto la fattura. Ora i campi
 *    compilati a metà aprono il modale con scritto cosa manca e si resta nel
 *    carrello. Un errore di rete invece non blocca niente, come prima.
 *
 * 4. PULSANTI DI PAGAMENTO RAPIDO — il codice intercettava ogni bottone di
 *    checkout, Shop Pay, PayPal e G Pay compresi, e li faceva finire tutti sul
 *    checkout normale. Ora, se nessun campo fattura è compilato, il clic non
 *    viene toccato: il carrello si comporta come quello originale del tema.
 *    L'intercettazione resta solo quando c'è davvero una fattura da salvare,
 *    perché lì i dati devono entrare nel carrello prima del pagamento.
 *
 * 5. VIA D'USCITA — gli attributi del carrello sopravvivono persino allo
 *    svuotamento del carrello: senza un modo per toglierli, una fattura chiesta
 *    una volta si sarebbe riattaccata a un ordine successivo. Il pulsante
 *    "Rimuovi" (in snippets/invoice-button.liquid) li cancella davvero.
 *
 * 6. CANCELLAZIONE CHE NON CANCELLAVA — per togliere un attributo Shopify vuole
 *    che glielo si rimandi VUOTO: ometterlo dalla chiamata non fa niente. Il
 *    codice invece lo toglieva dall'elenco, quindi nessuna rimozione andava mai
 *    a buon fine. Ora null e stringa vuota finiscono entrambi in un valore vuoto
 *    spedito a Shopify.
 *
 * 7. Partita IVA, codice fiscale e SDI vengono ripuliti prima del salvataggio
 *    (spazi, punti, eventuale prefisso IT, maiuscole). Nessun campo nuovo è
 *    diventato obbligatorio.
 */
(function () {
  if (window.__invoiceModalReady) return;
  window.__invoiceModalReady = true;

  var CAMPI = ['ragione_sociale', 'piva', 'cf', 'sdi', 'pec'];
  var modal = document.getElementById('invoiceModal');
  var errBox = document.getElementById('invoiceErrors');
  var successBox = document.getElementById('invoiceSuccess');
  var lastFocused = null;
  var successTimeout = null;
  var SUCCESS_CLOSE_DELAY_MS = 5000;
  var SELECTOR_CHECKOUT_BUTTONS = 'button[name="checkout"], .shopify-payment-button, [data-shopify-pay-button], button[data-gpay-button], button[data-apple-pay-button], button.checkout';
  var REDIRECT_FLAG = 'invoice_redirect_pending';
  var MEMORIA = 'invoice_attrs';
  var REDIRECT_TTL_MS = 15000;

  if (
    window.location.pathname.indexOf('/checkout') === 0 ||
    window.location.pathname.indexOf('/cart') === 0
  ) {
    try { localStorage.removeItem(REDIRECT_FLAG); } catch (e) {}
  }

  /* L'input nascosto si cerca per name: è quello che Shopify legge quando il
     form del carrello viene inviato. L'id resta solo come riserva. */
  function campoNascosto(chiave) {
    return document.querySelector('[name="attributes[' + chiave + ']"]') ||
           document.getElementById('cart-attribute-' + String(chiave).replace(/_/g, '-').toLowerCase());
  }
  function campoModale(chiave) { return document.getElementById(chiave); }

  if (!window.updateCartAttributes) {
    if (!window.__cartUpdateQueue) window.__cartUpdateQueue = Promise.resolve();

    window.updateCartAttributes = function (newAttrs, opts) {
      opts = opts || {};
      var updateHidden = typeof opts.updateHidden === 'undefined' ? true : !!opts.updateHidden;
      if (!newAttrs || typeof newAttrs !== 'object') return Promise.reject(new Error('newAttrs deve essere un oggetto'));

      window.__cartUpdateQueue = window.__cartUpdateQueue.then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Impossibile leggere /cart.js: ' + res.status);
            return res.json();
          })
          .then(function (cart) {
            var current = cart.attributes || {};
            var merged = {};
            Object.keys(current).forEach(function (k) { merged[k] = current[k]; });
            // Vuoto, non assente: è l'unico modo per cui Shopify cancella davvero.
            Object.keys(newAttrs).forEach(function (k) {
              merged[k] = newAttrs[k] === null ? '' : newAttrs[k];
            });

            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ attributes: merged })
            })
              .then(function (res) {
                if (!res.ok) {
                  return res.text().then(function (text) {
                    var err = new Error('Errore update cart: ' + res.status + ' - ' + text);
                    err.status = res.status; err.body = text;
                    throw err;
                  });
                }
                return res.json();
              })
              .then(function (updatedCart) {
                if (updateHidden) {
                  try {
                    Object.keys(merged || {}).forEach(function (key) {
                      var el = campoNascosto(key);
                      if (el) el.value = merged[key] == null ? '' : merged[key];
                    });
                  } catch (e) {}
                }
                return updatedCart;
              });
          });
      });

      return window.__cartUpdateQueue;
    };
  }

  function setRedirectFlag() {
    try { localStorage.setItem(REDIRECT_FLAG, JSON.stringify({ ts: Date.now() })); } catch (e) {}
  }
  function clearRedirectFlag() {
    try { localStorage.removeItem(REDIRECT_FLAG); } catch (e) {}
  }
  function getRedirectFlagAge() {
    try {
      var raw = localStorage.getItem(REDIRECT_FLAG);
      if (!raw) return Infinity;
      var obj = JSON.parse(raw);
      return Date.now() - (obj && obj.ts ? obj.ts : 0);
    } catch (e) { return Infinity; }
  }

  function waitUntilReady(selector, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      function check() {
        try {
          var el = document.querySelector(selector);
          if (el && !el.disabled) return resolve(el);
          if (Date.now() - started > timeoutMs) return reject(new Error('timeout'));
          setTimeout(check, 120);
        } catch (e) {
          if (Date.now() - started > timeoutMs) return reject(new Error('timeout'));
          setTimeout(check, 120);
        }
      }
      check();
    });
  }

  function nascondiMessaggi() {
    if (errBox) { errBox.style.display = 'none'; errBox.textContent = ''; }
    if (successBox) { successBox.style.display = 'none'; successBox.textContent = ''; }
  }

  function mostraModale() {
    if (!modal) return;
    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', onKeydown);
  }

  /* La memoria del browser riempie il modale, non decide: serve al cliente
     abituale che non vuole ridigitare tutto. */
  function riempiDaMemoria() {
    try {
      var vuoti = CAMPI.every(function (k) {
        var el = campoModale(k);
        return !el || !el.value;
      });
      if (!vuoti) return;
      var salvati = JSON.parse(localStorage.getItem(MEMORIA) || 'null');
      if (!salvati) return;
      CAMPI.forEach(function (k) {
        var el = campoModale(k);
        if (el && salvati[k]) el.value = salvati[k];
      });
    } catch (e) {}
  }

  function openInvoiceModal(triggerEl) {
    if (!modal) return;
    lastFocused = triggerEl || document.activeElement;
    nascondiMessaggi();
    riempiDaMemoria();
    mostraModale();
    var first = campoModale('ragione_sociale');
    if (first) first.focus();
  }
  function closeInvoiceModal() {
    if (!modal) return;
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    if (successTimeout) { clearTimeout(successTimeout); successTimeout = null; }
  }
  function onKeydown(e) { if (e.key === 'Escape') closeInvoiceModal(); }

  /* Quello che c'è adesso a schermo, o in mancanza quello che il carrello ha
     già salvato. Nient'altro. */
  function leggiValori() {
    var v = {};
    CAMPI.forEach(function (k) {
      var m = campoModale(k);
      var h = campoNascosto(k);
      var val = (m && m.value) || (h && h.value) || '';
      v[k] = String(val).trim();
    });
    return v;
  }

  function nessunDato(v) {
    return !CAMPI.some(function (k) { return v[k] !== ''; });
  }

  function ripulisci(v) {
    return {
      ragione_sociale: v.ragione_sociale,
      piva: v.piva.replace(/[\s.\-]/g, '').replace(/^IT/i, '').toUpperCase(),
      cf: v.cf.replace(/[\s.\-]/g, '').toUpperCase(),
      sdi: v.sdi.replace(/\s/g, '').toUpperCase(),
      pec: v.pec.toLowerCase()
    };
  }

  function erroriDi(v) {
    var e = [];
    if (!v.ragione_sociale) e.push('- Ragione Sociale obbligatoria');
    if (!v.piva) e.push('- Partita IVA obbligatoria');
    if (!v.sdi && !v.pec) e.push('- Devi compilare almeno SDI o PEC');
    return e;
  }

  function showValidationErrors(text) {
    mostraModale();
    if (!errBox) { alert('Devi compilare i seguenti campi:\n' + text); return; }
    errBox.textContent = 'Devi compilare i seguenti campi:\n' + text;
    errBox.style.display = 'block';
    if (successBox) { successBox.style.display = 'none'; successBox.textContent = ''; }
  }

  function showSuccessMessage(msg, redirectAfter) {
    if (!successBox) { try { alert(msg); } catch (e) {} if (!redirectAfter) return; }
    successBox.textContent = msg;
    successBox.style.display = 'block';
    if (errBox) { errBox.style.display = 'none'; errBox.textContent = ''; }
    if (!redirectAfter) {
      if (successTimeout) clearTimeout(successTimeout);
      successTimeout = setTimeout(function () { try { closeInvoiceModal(); } catch (e) {} }, SUCCESS_CLOSE_DELAY_MS);
    }
  }

  function performRedirectToCheckout() {
    window.location.href = '/checkout';
  }

  function saveInvoiceAndMaybeRedirect(redirectAfter) {
    var v = ripulisci(leggiValori());
    var errori = erroriDi(v);

    if (errori.length) {
      showValidationErrors(errori.join('\n'));
      return Promise.reject(new Error('validation'));
    }

    // I campi a schermo tornano uguali ai dati salvati.
    CAMPI.forEach(function (k) {
      var el = campoModale(k);
      if (el && el.value !== v[k]) el.value = v[k];
    });

    var checkoutButtons = Array.prototype.slice.call(document.querySelectorAll(SELECTOR_CHECKOUT_BUTTONS));
    checkoutButtons.forEach(function (b) { try { b.disabled = true; b.classList && b.classList.add('disabled'); } catch (e) {} });

    nascondiMessaggi();
    try { if (redirectAfter) setRedirectFlag(); } catch (e) {}

    return window.updateCartAttributes(v, { updateHidden: true })
      .then(function (cart) {
        try { localStorage.setItem(MEMORIA, JSON.stringify(v)); } catch (e) {}
        checkoutButtons.forEach(function (b) { try { b.disabled = false; b.classList && b.classList.remove('disabled'); } catch (e) {} });

        if (redirectAfter) {
          performRedirectToCheckout();
          return cart;
        }
        showSuccessMessage("Dati salvati correttamente. Ricordati di inserire l'indirizzo di fatturazione al checkout.", false);
        return cart;
      })
      .catch(function (err) {
        // Problema di rete, non di dati: il cliente non si blocca.
        try { clearRedirectFlag(); } catch (e) {}
        checkoutButtons.forEach(function (b) { try { b.disabled = false; b.classList.remove('disabled'); } catch (e) {} });
        var msg = 'Errore nel salvataggio dei dati. Puoi comunque procedere al checkout.';
        if (errBox) { errBox.textContent = msg; errBox.style.display = 'block'; mostraModale(); }
        else { alert(msg); }
        if (redirectAfter) {
          alert('Si è verificato un errore, ma puoi comunque procedere al checkout.');
          performRedirectToCheckout();
        }
        throw err;
      });
  }

  function rimuoviDatiFattura(btn) {
    var azzerati = {};
    CAMPI.forEach(function (k) { azzerati[k] = ''; });
    CAMPI.forEach(function (k) {
      var el = campoModale(k);
      if (el) el.value = '';
    });
    try { localStorage.removeItem(MEMORIA); } catch (e) {}
    if (btn) { try { btn.disabled = true; } catch (e) {} }

    return window.updateCartAttributes(azzerati, { updateHidden: true })
      .then(function () { window.location.reload(); })
      .catch(function () {
        if (btn) { try { btn.disabled = false; } catch (e) {} }
        alert('Non sono riuscito a rimuovere i dati della fattura. Riprova.');
      });
  }

  function maybeFlushPendingRedirect() {
    try {
      var age = getRedirectFlagAge();
      if (age === Infinity) return;
      if (age > REDIRECT_TTL_MS) { clearRedirectFlag(); return; }
      if (window.location.pathname.indexOf('/checkout') === 0) { clearRedirectFlag(); return; }

      waitUntilReady('#cart, ' + SELECTOR_CHECKOUT_BUTTONS, 5000)
        .then(function () { performRedirectToCheckout(); })
        .catch(function () { performRedirectToCheckout(); });
    } catch (e) {}
  }

  document.body.addEventListener('click', function (e) {
    var openBtn = e.target.closest ? e.target.closest('#openInvoiceForm') : null;
    var closeBtn = e.target.closest ? e.target.closest('#closeInvoiceForm') : null;
    var saveBtn = e.target.closest ? e.target.closest('#saveInvoiceData') : null;
    var removeBtn = e.target.closest ? e.target.closest('#removeInvoiceData') : null;

    if (openBtn) { e.preventDefault(); openInvoiceModal(openBtn); return; }
    if (closeBtn) { e.preventDefault(); closeInvoiceModal(); return; }
    if (saveBtn) { e.preventDefault(); saveInvoiceAndMaybeRedirect(false).catch(function () {}); return; }
    if (removeBtn) { e.preventDefault(); rimuoviDatiFattura(removeBtn); return; }
  });

  /* Nessun campo compilato = nessuna fattura richiesta: il clic non viene
     toccato e il bottone fa quello che farebbe nel tema originale, pagamenti
     rapidi compresi. Si interviene solo quando c'è una fattura da salvare. */
  document.body.addEventListener('click', function (e) {
    var checkoutClicked = e.target.closest ? e.target.closest(SELECTOR_CHECKOUT_BUTTONS) : null;
    if (!checkoutClicked) return;
    if (nessunDato(leggiValori())) return;

    e.preventDefault();
    e.stopPropagation();
    saveInvoiceAndMaybeRedirect(true).catch(function () {});
  }, true);

  var cartForm = document.getElementById('cart');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      var isCheckoutSubmit = false;
      try {
        if (e.submitter && (e.submitter.name === 'checkout' || (e.submitter.closest && e.submitter.closest(SELECTOR_CHECKOUT_BUTTONS)))) {
          isCheckoutSubmit = true;
        }
      } catch (err) {}
      if (!isCheckoutSubmit) {
        try {
          var active = document.activeElement;
          if (active && active.closest && active.closest(SELECTOR_CHECKOUT_BUTTONS)) isCheckoutSubmit = true;
        } catch (err) {}
      }
      if (!isCheckoutSubmit) return;
      if (nessunDato(leggiValori())) return;

      e.preventDefault();
      saveInvoiceAndMaybeRedirect(true).catch(function () {});
    });
  }

  document.addEventListener('on:line-item:change', function (e) {
    maybeFlushPendingRedirect();

    var itemCount = e.detail && e.detail.cart && typeof e.detail.cart.item_count !== 'undefined'
      ? e.detail.cart.item_count
      : 0;
    var invoiceBtn = document.querySelector('.invoice-request-wrapper');
    var box = document.getElementById('invoiceModal');
    if (itemCount === 0) {
      if (invoiceBtn) invoiceBtn.style.display = 'none';
      if (box) box.style.display = 'none';
    } else {
      if (invoiceBtn) invoiceBtn.style.display = '';
      if (box) box.style.display = '';
    }
  });

  document.addEventListener('DOMContentLoaded', function () { maybeFlushPendingRedirect(); });
  document.addEventListener('click', function (e) { if (e.target === modal) closeInvoiceModal(); });

  try { window.saveInvoiceAndMaybeRedirect = saveInvoiceAndMaybeRedirect; } catch (e) {}
})();